import Vue from 'vue'
import VueRouter from 'vue-router'

import Inicio from '@/views/ajuda/inicio'
// import Login from '@/views/ajuda/login'
import Ajuda from '@/views/ajuda/ajuda'
import Faq from '@/views/ajuda/faq'
import PageNotFound from '@/views/ajuda/404'
import store from '@/vuex/store'
import auth from '@/utils/auth'
import projetos from '@/utils/projetos'

import ListaBolsas from '@/views/bolsas/lista-bolsas'
import CriarBolsa from '@/views/bolsas/criar-bolsa'
import AlocarBolsa from '@/views/bolsas/alocar-bolsa'
import AlocarBolsasEmMassa from '@/views/bolsas/alocar-bolsa-tabela'
import AtribuirBolsa from '@/views/bolsas/atribuir-bolsa'
import DadosBancarios from '@/views/bolsas/dados-bancarios'
import AvaliacaoCoordenador from '@/views/bolsas/avaliacao-coordenador'
import AvaliacaoBolsista from '@/views/bolsas/avaliacao-bolsista'

import ConsultaProjetos from '@/views/consulta-projetos/consulta-projetos'
import MeusProjetos from '@/views/consulta-projetos/meus-projetos'
import Projeto from '@/views/projeto/projeto'

import EditarProjeto from '@/views/editar-projeto/editar-projeto'
import NovoProjeto from '@/views/editar-projeto/novo-projeto'
import UploadArquivo from '@/views/editar-projeto/upload-arquivo'
import EditarArquivo from '@/views/editar-projeto/editar-arquivo'
import ImportarProjeto from '@/views/editar-projeto/importar-projeto'
import DuplicarProjeto from '@/views/editar-projeto/duplicar-projeto'

import ProjetoFormulario from '@/views/projeto/projeto-formulario'
import ClassificacoesProjeto from '@/views/projeto/projeto-classificacoes-tabela'
import ExtensaoProjeto from '@/views/projeto/projeto-extensao'
import ContatosProjeto from '@/views/projeto/projeto-contatos'
import IntegrantesProjeto from '@/views/projeto/projeto-integrantes-tabela'
import AtividadesProjeto from '@/views/projeto/projeto-atividades-tabela'
import VinculosProjeto from '@/views/projeto/projeto-vinculos-tabela'
import ParceriasProjeto from '@/views/projeto/projeto-parcerias-tabela'
import AbrangenciaProjeto from '@/views/projeto/projeto-abrangencia-tabela'
import BolsasProjeto from '@/views/projeto/projeto-bolsas-tabela'
import ArquivosProjeto from '@/views/projeto/projeto-arquivos-tabela'
import RelatoriosProjeto from '@/views/projeto/projeto-relatorios-tabela'

import EditarInformacoes from '@/views/editar-projeto/editar-informacoes'
import EditarClassificacao from '@/views/editar-projeto/editar-classificacao'
import EditarExtensao from '@/views/editar-projeto/editar-extensao'
import EditarContatos from '@/views/editar-projeto/editar-contatos'
import EditarIntegrantes from '@/views/editar-projeto/projeto-editar-integrantes'
import EditarParcerias from '@/views/editar-projeto/projeto-editar-parcerias'
import EditarAtividades from '@/views/editar-projeto/projeto-editar-atividades'
import EditarAbrangencia from '@/views/editar-projeto/projeto-editar-abrangencia'
import EditarArquivos from '@/views/editar-projeto/projeto-editar-arquivos'
import EditarLocalidade from '@/views/editar-projeto/editar-localidade'
import EditarProjetoSuperior from '@/views/editar-projeto/editar-projeto-superior'

import EditarIntegrante from '@/views/integrantes/editar-integrante'
import VisualizarIntegrante from '@/views/integrantes/visualizar-integrante'
import NovoIntegrante from '@/views/integrantes/novo-integrante'
import AdicionarIntegrante from '@/views/integrantes/adicionar-integrante'
import EncerrarParticipacao from '@/views/integrantes/encerrar-participacao'
import ReativarParticipacao from '@/views/integrantes/reativar-participacao'
import OcorrenciasIntegrante from '@/views/integrantes/ocorrencias-integrante'
import TrocarCoordenador from '@/views/integrantes/trocar-coordenador'
import NovaAtividade from '@/views/editar-projeto/nova-atividade'
import NovaParceria from '@/views/editar-projeto/nova-parceria'
import NovaLocalidade from '@/views/editar-projeto/nova-localidade'
import EditarAtividade from '@/views/editar-projeto/editar-atividade'
import EditarParceria from '@/views/editar-projeto/editar-parceria'

import NovaPessoa from '@/views/editar-projeto/nova-pessoa'
import CadastrarMembroExterno from '@/views/editar-projeto/novo-membro-externo'
import EditarPessoa from '@/views/editar-projeto/editar-pessoa'
import Relatorio from '@/views/consulta-projetos/relatorio'
import ProjetosAguardandoAprovacao from '@/views/administracao/projetos-aprovar-tabela'
import RelatoriosAguardandoAprovacao from '@/views/administracao/relatorios-aprovar-tabela'
import ProjetosVencidos from '@/views/administracao/projetos-vencidos-tabela'
import ProjetosConcluir from '@/views/administracao/projetos-concluir-tabela'
import Administracao from '@/views/administracao/administracao'
import Pesquisa from '@/views/ajuda/pesquisa'
import AprovarProjeto from '@/views/administracao/aprovar-projeto'
import DevolverProjeto from '@/views/administracao/devolver-projeto'
import LiberarRelatorio from '@/views/administracao/liberar-relatorio'
import InabilitarProjeto from '@/views/administracao/inabilitar-projeto'
import AlterarClassificacaoSecundaria from '@/views/administracao/alterar-classificacao-secundaria'
import SuspenderAcaoExtensao from '@/views/administracao/suspender-acao-extensao'
import ReativarAcaoExtensao from '@/views/administracao/reativar-acao-extensao'
import FinalizarAcao from '@/views/editar-projeto/finalizar-projeto'
import ConcluirProjeto from '@/views/administracao/concluir-projeto'
import CancelarProjeto from '@/views/administracao/cancelar-projeto'
import DesfazerFinalizacao from '@/views/administracao/desfazer-finalizacao'
import DesfazerExclusao from '@/views/administracao/desfazer-exclusao'
import ProjetosParceiros from '@/views/administracao/parcerias-tabela'
import RelatoriosGestao from '@/views/administracao/relatorios-gestao-tabela'
import NovaMensagem from '@/views/administracao/nova-mensagem'
import UsuariosProex from '@/views/administracao/usuarios-proex'
import DefinirPeriodoFrequencia from '@/views/administracao/definir-periodo-frequencia'
import RelatorioSeguro from '@/views/administracao/relatorio-seguro'
import ReprovarRelatorioComSuspensaoDeCoordenador from '@/views/administracao/reprovar-relatorios-suspensao-coordenador'
import RegistrarEnvioDeRelatorioDeProjeto from '@/views/administracao/registro-envio-relatorios-projeto'

import SubmeterRelatorio from '@/views/relatorio/submeter'
import AprovarRelatorio from '@/views/relatorio/aprovar'
import DevolverRelatorio from '@/views/relatorio/devolver'
import ReprovarRelatorio from '@/views/relatorio/reprovar'
import NovoRelatorio from '@/views/relatorio/novo-relatorio-tecnico'
import EditarRelatorio from '@/views/relatorio/editar-relatorio'
import RelatorioTecnico from '@/views/relatorio/relatorio-tecnico'
import RelatorioTecnicoPDF from '@/views/relatorio/relatorio-tecnico-pdf'

import FrequenciaIntegrante from '@/views/frequencia/lista-frequencia'
import CriarFrequencia from '@/views/frequencia/criar-frequencia'

import AtivarDesativarAdministrador from '@/views/administracao/ativar-desativar-administrador'

import NovoProjetoPesquisa from '@/views/pesquisa/novo-projeto-pesquisa'
import MeusProjetosPesquisa from '@/views/pesquisa/meus-projetos-pesquisa'
import ConsultaProjetosPesquisa from '@/views/pesquisa/consulta-projetos-pesquisa'

import ProjetoPesquisa from '@/views/pesquisa/projeto-pesquisa'
import ProjetoPesquisaInformacoesBasicas from '@/views/pesquisa/informacoes-basicas'
import ProjetoPesquisaDetalhamento from '@/views/pesquisa/detalhamento'
import ProjetoPesquisaInstituicoes from '@/views/pesquisa/instituicoes'
import ProjetoPesquisaPesquisarInstituicao from '@/views/pesquisa/pesquisar-instituicao'
import ProjetoPesquisaAdicionarInstituicao from '@/views/pesquisa/adicionar-instituicao'
import ProjetoPesquisaCadastrarInstituicao from '@/views/pesquisa/cadastrar-instituicao'
import ProjetoPesquisaEquipe from '@/views/pesquisa/equipe'
import ProjetoPesquisaPesquisarPessoas from '@/views/pesquisa/pesquisar-pessoas'
import ProjetoPesquisaAdicionarMembroEquipe from '@/views/pesquisa/adicionar-membro-equipe'
import ProjetoPesquisaCadastrarMembroExterno from '@/views/pesquisa/cadastrar-membro-externo'
import ProjetoPesquisaOrgaosFinanciadores from '@/views/pesquisa/orgaos-financiadores'
import ProjetoPesquisaPesquisarOrgaoFinanciador from '@/views/pesquisa/pesquisar-orgao-financiador'
import ProjetoPesquisaAdicionarOrgaoFinanciador from '@/views/pesquisa/adicionar-orgao-financiador'
import ProjetoPesquisaCadastrarOrgaoFinanciador from '@/views/pesquisa/cadastrar-orgao-financiador'
import ProjetoPesquisaOutrasInformacoes from '@/views/pesquisa/outras-informacoes'
import ProjetoPesquisaArquivos from '@/views/pesquisa/arquivos'
import ProjetoPesquisaAdicionarArquivo from '@/views/pesquisa/adicionar-arquivo'
import ProjetoPesquisaContatos from '@/views/pesquisa/contatos'
import ProjetoPesquisaResultadosObtidos from '@/views/pesquisa/resultados-obtidos'

import EditarProjetoPesquisa from '@/views/pesquisa/editar-projeto-pesquisa'
import EditarProjetoPesquisaInformacoesBasicas from '@/views/pesquisa/editar-informacoes-basicas'
import EditarProjetoPesquisaDetalhamento from '@/views/pesquisa/editar-detalhamento'
import EditarProjetoPesquisaInstituicao from '@/views/pesquisa/editar-instituicao'
import EditarProjetoPesquisaOrgaoFinanciador from '@/views/pesquisa/editar-orgao-financiador'
import EditarProjetoPesquisaMembroEquipe from '@/views/pesquisa/editar-membro-equipe'
import FinalizarParticipacaoProjetoPesquisaMembroEquipe from '@/views/pesquisa/finalizar-membro-equipe'
import EditarProjetoPesquisaOutrasInformacoes from '@/views/pesquisa/editar-outras-informacoes'
import EditarProjetoPesquisaContatos from '@/views/pesquisa/editar-contatos'
import EditarProjetoPesquisaResultadosObtidos from '@/views/pesquisa/editar-resultados-obtidos'
import EditarProjetoPesquisaArquivo from '@/views/pesquisa/editar-arquivo'

import AjudaPesquisa from '@/views/pesquisa/ajuda-pesquisa'

Vue.use(VueRouter)

// const SSO_URL = 'https://sso.ufes.br'
const PIB_API_URL = process.env.API_BASE_URL

const router = new VueRouter({
  routes: [
    {
      path: '*',
      redirect: {name: '404'}
    },
    {
      path: '/',
      redirect: {name: 'Inicio'}
    },
    {
      path: '/inicio',
      name: 'Inicio',
      component: Inicio
    },
    {
      path: '/login',
      name: 'Login',
      component: MeusProjetos,
      meta: { requiresAuth: true }
    },
    {
      path: '/bolsas',
      name: 'ListaBolsas',
      component: ListaBolsas,
      meta: { requiresAuth: true }
    },
    {
      path: '/criar-bolsa',
      name: 'CriarBolsa',
      component: CriarBolsa,
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/alocar-bolsa',
      name: 'AlocarBolsa',
      component: AlocarBolsa,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/alocar-bolsas-em-massa',
      name: 'AlocarBolsasEmMassa',
      component: AlocarBolsasEmMassa,
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/atribuir-bolsa',
      name: 'AtribuirBolsa',
      component: AtribuirBolsa,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/dados-bancarios',
      name: 'DadosBancarios',
      component: DadosBancarios,
      meta: { requiresAuth: true }
    },
    {
      path: '/avaliacao-coordenador',
      name: 'AvaliacaoCoordenador',
      component: AvaliacaoCoordenador,
      meta: { requiresAuth: true }
    },
    {
      path: '/avaliacao-bolsista',
      name: 'AvaliacaoBolsista',
      component: AvaliacaoBolsista,
      meta: { requiresAuth: true }
    },
    {
      path: '/consulta-projetos',
      name: 'ConsultaProjetos',
      component: ConsultaProjetos
    },
    {
      path: '/meus-projetos',
      name: 'MeusProjetos',
      component: MeusProjetos,
      meta: { requiresAuth: true }
    },
    {
      path: '/novo-projeto',
      name: 'NovoProjeto',
      component: NovoProjeto,
      meta: { requiresAuth: true }
    },
    {
      path: '/importar-projeto',
      name: 'ImportarProjeto',
      component: ImportarProjeto,
      meta: { requiresAuth: true }
    },
    {
      path: '/duplicar-projeto',
      name: 'DuplicarProjeto',
      component: DuplicarProjeto,
      meta: { requiresAuth: true }
    },
    { // Página "Novo Projeto de Pesquisa"
      path: '/pesquisa/novo-projeto',
      name: 'NovoProjetoPesquisa',
      component: NovoProjetoPesquisa,
      meta: { requiresAuth: true }
    },
    { // Página "Meus Projetos de Pesquisa"
      path: '/pesquisa/meus-projetos',
      name: 'MeusProjetosPesquisa',
      component: MeusProjetosPesquisa,
      meta: { requiresAuth: true }
    },
    { // Página "Consultar Projetos de Pesquisa"
      path: '/pesquisa/consulta-projetos',
      name: 'ConsultaProjetosPesquisa',
      component: ConsultaProjetosPesquisa,
      meta: { requiresAuth: false }
    },
    // Página de ajuda para o cadastro dos projetos de pesquisa.
    {
      path: '/pesquisa/ajuda',
      name: 'AjudaPesquisa',
      component: AjudaPesquisa
    },
    { // Visualização de um Projeto de Pesquisa"
      path: '/pesquisa/projetos/:idProjetoPesquisa',
      name: 'ProjetoPesquisa',
      component: ProjetoPesquisa,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa}),
      meta: { requiresAuth: false },
      children:
      [
        { // Aba "Informações Básicas"
          path: 'informacoes-basicas',
          name: 'ProjetoPesquisaInformacoesBasicas',
          component: ProjetoPesquisaInformacoesBasicas
        },
        { // Aba "Detalhamento"
          path: 'detalhamento',
          name: 'ProjetoPesquisaDetalhamento',
          component: ProjetoPesquisaDetalhamento
        },
        { // Aba "Instituições"
          path: 'instituicoes',
          name: 'ProjetoPesquisaInstituicoes',
          component: ProjetoPesquisaInstituicoes
        },
        { // Aba "Equipe"
          path: 'equipe',
          name: 'ProjetoPesquisaEquipe',
          component: ProjetoPesquisaEquipe
        },
        { // Aba "Órgãos Financiadores"
          path: 'orgaos-financiadores',
          name: 'ProjetoPesquisaOrgaosFinanciadores',
          component: ProjetoPesquisaOrgaosFinanciadores
        },
        { // Aba "Outras Informações"
          path: 'outras-informacoes',
          name: 'ProjetoPesquisaOutrasInformacoes',
          component: ProjetoPesquisaOutrasInformacoes
        },
        { // Aba "Arquivos"
          path: 'arquivos',
          name: 'ProjetoPesquisaArquivos',
          component: ProjetoPesquisaArquivos
        },
        { // Aba "Contatos"
          path: 'contatos',
          name: 'ProjetoPesquisaContatos',
          component: ProjetoPesquisaContatos
        },
        { // Aba "Resultados Obtidos"
          path: 'resultados-obtidos',
          name: 'ProjetoPesquisaResultadosObtidos',
          component: ProjetoPesquisaResultadosObtidos
        }
      ]
    },
    { // Edição de um Projeto de Pesquisa"
      path: '/pesquisa/projetos/:idProjetoPesquisa/editar',
      name: 'EditarProjetoPesquisa',
      component: EditarProjetoPesquisa,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa}),
      meta: { requiresAuth: true },
      children:
      [
        {  // Editar aba "Informações Básicas"
          path: 'informacoes-basicas',
          name: 'EditarProjetoPesquisaInformacoesBasicas',
          component: EditarProjetoPesquisaInformacoesBasicas
        },
        {  // Editar aba "Detalhamento"
          path: 'detalhamento',
          name: 'EditarProjetoPesquisaDetalhamento',
          component: EditarProjetoPesquisaDetalhamento
        },
        {  // Editar aba "Outras Informações"
          path: 'outras-informacoes',
          name: 'EditarProjetoPesquisaOutrasInformacoes',
          component: EditarProjetoPesquisaOutrasInformacoes
        },
        {  // Editar aba "Contatos"
          path: 'contatos',
          name: 'EditarProjetoPesquisaContatos',
          component: EditarProjetoPesquisaContatos
        },
        {  // Editar aba "Resultados Obtidos"
          path: 'resultados-obtidos',
          name: 'EditarProjetoPesquisaResultadosObtidos',
          component: EditarProjetoPesquisaResultadosObtidos
        }
      ]
    },
    { // Editar Instituição Projeto Pesquisa.
      path: '/pesquisa/projetos/:idProjetoPesquisa/instituicoes/editar/:idInstituicaoProjetoPesquisa',
      name: 'EditarProjetoPesquisaInstituicao',
      component: EditarProjetoPesquisaInstituicao,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa, idInstituicaoProjetoPesquisa: route.params.idInstituicaoProjetoPesquisa}),
      meta: { requiresAuth: true }
    },
    { // Pesquisar Instituição.
      path: '/pesquisa/projetos/:idProjetoPesquisa/instituicoes/adicionar',
      name: 'ProjetoPesquisaPesquisarInstituicao',
      component: ProjetoPesquisaPesquisarInstituicao,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa}),
      meta: { requiresAuth: true }
    },
    { // Adicionar Instituição Projeto Pesquisa.
      path: '/pesquisa/projetos/:idProjetoPesquisa/instituicoes/adicionar/:idInstituicao',
      name: 'ProjetoPesquisaAdicionarInstituicao',
      component: ProjetoPesquisaAdicionarInstituicao,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa, idInstituicao: route.params.idInstituicao}),
      meta: { requiresAuth: true }
    },
    { // Cadastrar Instituição.
      path: '/pesquisa/projetos/:idProjetoPesquisa/instituicoes/cadastrar',
      name: 'ProjetoPesquisaCadastrarInstituicao',
      component: ProjetoPesquisaCadastrarInstituicao,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa}),
      meta: { requiresAuth: true }
    },
    { // Editar Membro da Equipe.
      path: '/pesquisa/projetos/:idProjetoPesquisa/equipe/editar/:idParticipanteProjetoPesquisa',
      name: 'EditarProjetoPesquisaMembroEquipe',
      component: EditarProjetoPesquisaMembroEquipe,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa, idParticipanteProjetoPesquisa: route.params.idParticipanteProjetoPesquisa}),
      meta: { requiresAuth: true }
    },
    { // Finalizar Membro da Equipe.
      path: '/pesquisa/projetos/:idProjetoPesquisa/equipe/finalizar/:idParticipanteProjetoPesquisa',
      name: 'FinalizarParticipacaoProjetoPesquisaMembroEquipe',
      component: FinalizarParticipacaoProjetoPesquisaMembroEquipe,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa, idParticipanteProjetoPesquisa: route.params.idParticipanteProjetoPesquisa}),
      meta: { requiresAuth: true }
    },
    { // Pesquisar Pessoas.
      path: '/pesquisa/projetos/:idProjetoPesquisa/equipe/adicionar',
      name: 'ProjetoPesquisaPesquisarPessoas',
      component: ProjetoPesquisaPesquisarPessoas,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa}),
      meta: { requiresAuth: true }
    },
    { // Adicionar Membro da Equipe.
      path: '/pesquisa/projetos/:idProjetoPesquisa/equipe/adicionar/:idPessoa',
      name: 'ProjetoPesquisaAdicionarMembroEquipe',
      component: ProjetoPesquisaAdicionarMembroEquipe,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa, idPessoa: route.params.idPessoa}),
      meta: { requiresAuth: true }
    },
    { // Cadastrar Membro Externo.
      path: '/pesquisa/projetos/:idProjetoPesquisa/equipe/cadastrar-membro-externo',
      name: 'ProjetoPesquisaCadastrarMembroExterno',
      component: ProjetoPesquisaCadastrarMembroExterno,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa}),
      meta: { requiresAuth: true }
    },
    { // Editar Órgão Financiador Projeto Pesquisa.
      path: '/pesquisa/projetos/:idProjetoPesquisa/orgaos-financiadores/editar/:idOrgaoFinanciadorProjetoPesquisa',
      name: 'EditarProjetoPesquisaOrgaoFinanciador',
      component: EditarProjetoPesquisaOrgaoFinanciador,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa, idOrgaoFinanciadorProjetoPesquisa: route.params.idOrgaoFinanciadorProjetoPesquisa}),
      meta: { requiresAuth: true }
    },
    { // Pesquisar Órgão Financiador.
      path: '/pesquisa/projetos/:idProjetoPesquisa/orgaos-financiadores/adicionar',
      name: 'ProjetoPesquisaPesquisarOrgaoFinanciador',
      component: ProjetoPesquisaPesquisarOrgaoFinanciador,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa}),
      meta: { requiresAuth: true }
    },
    { // Adicionar Órgão Financiador Projeto Pesquisa.
      path: '/pesquisa/projetos/:idProjetoPesquisa/orgaos-financiadores/adicionar/:idOrgaoFinanciador',
      name: 'ProjetoPesquisaAdicionarOrgaoFinanciador',
      component: ProjetoPesquisaAdicionarOrgaoFinanciador,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa, idOrgaoFinanciador: route.params.idOrgaoFinanciador}),
      meta: { requiresAuth: true }
    },
    { // Cadastrar Órgão Financiador.
      path: '/pesquisa/projetos/:idProjetoPesquisa/orgaos-financiadores/cadastrar',
      name: 'ProjetoPesquisaCadastrarOrgaoFinanciador',
      component: ProjetoPesquisaCadastrarOrgaoFinanciador,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa}),
      meta: { requiresAuth: true }
    },
    { // Editar Arquivo Projeto Pesquisa.
      path: '/pesquisa/projetos/:idProjetoPesquisa/arquivos/editar/:idArquivoProjetoPesquisa',
      name: 'EditarProjetoPesquisaArquivo',
      component: EditarProjetoPesquisaArquivo,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa, idArquivoProjetoPesquisa: route.params.idArquivoProjetoPesquisa}),
      meta: { requiresAuth: true }
    },
    { // Adicionar Arquivo Projeto Pesquisa.
      path: '/pesquisa/projetos/:idProjetoPesquisa/arquivos/adicionar',
      name: 'ProjetoPesquisaAdicionarArquivo',
      component: ProjetoPesquisaAdicionarArquivo,
      props: (route) => ({idProjetoPesquisa: route.params.idProjetoPesquisa}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto',
      name: 'Projeto',
      component: Projeto,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      children:
      [
        {
          path: 'informacoes',
          name: 'ProjetoFormulario',
          component: ProjetoFormulario
        },
        {
          path: 'classificacoes',
          name: 'ClassificacoesProjeto',
          component: ClassificacoesProjeto
        },
        {
          path: 'extensao',
          name: 'ExtensaoProjeto',
          component: ExtensaoProjeto
        },
        {
          path: 'contatos',
          name: 'ContatosProjeto',
          component: ContatosProjeto
        },
        {
          path: 'integrantes',
          name: 'IntegrantesProjeto',
          component: IntegrantesProjeto
        },
        {
          path: 'atividades',
          name: 'AtividadesProjeto',
          component: AtividadesProjeto
        },
        {
          path: 'vinculos',
          name: 'VinculosProjeto',
          component: VinculosProjeto
        },
        {
          path: 'parcerias',
          name: 'ParceriasProjeto',
          component: ParceriasProjeto
        },
        {
          path: 'abrangencia',
          name: 'AbrangenciaProjeto',
          component: AbrangenciaProjeto
        },
        {
          path: 'bolsas',
          name: 'BolsasProjeto',
          component: BolsasProjeto
        },
        {
          path: 'arquivos',
          name: 'ArquivosProjeto',
          component: ArquivosProjeto
        },
        {
          path: 'relatorios',
          name: 'RelatoriosProjeto',
          component: RelatoriosProjeto
        }
      ]
    },
    {
      path: '/editar-projetos/:idProjeto',
      name: 'EditarProjeto',
      component: EditarProjeto,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true },
      children:
      [
        {
          path: 'informacoes',
          name: 'EditarInformacoes',
          component: EditarInformacoes
        },
        {
          path: 'editar-classificacao',
          name: 'EditarClassificacao',
          component: EditarClassificacao
        },
        {
          path: 'editar-extensao',
          name: 'EditarExtensao',
          component: EditarExtensao
        },
        {
          path: 'editar-contatos',
          name: 'EditarContatos',
          component: EditarContatos
        },
        {
          path: 'editar-integrantes',
          name: 'EditarIntegrantes',
          component: EditarIntegrantes
        },
        {
          path: 'editar-atividades',
          name: 'EditarAtividades',
          component: EditarAtividades
        },
        {
          path: 'editar-parcerias',
          name: 'EditarParcerias',
          component: EditarParcerias
        },
        {
          path: 'editar-abrangencia',
          name: 'EditarAbrangencia',
          component: EditarAbrangencia
        },
        {
          path: 'editar-arquivos',
          name: 'EditarArquivos',
          component: EditarArquivos
        }
      ]
    },
    {
      path: '/projetos/:idProjeto/integrantes/novo',
      name: 'NovoIntegrante',
      component: NovoIntegrante,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/integrantes/adicionar/:idPessoa',
      name: 'AdicionarIntegrante',
      component: AdicionarIntegrante,
      props: (route) => ({idProjeto: route.params.idProjeto, idPessoa: route.params.idPessoa}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/integrantes/:idParticipante/editar',
      name: 'EditarIntegrante',
      component: EditarIntegrante,
      props: (route) => ({idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/integrantes/:idParticipante/visualizar',
      name: 'VisualizarIntegrante',
      component: VisualizarIntegrante,
      props: (route) => ({idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/integrantes/:idParticipante/encerrar',
      name: 'EncerrarParticipacao',
      component: EncerrarParticipacao,
      props: (route) => ({idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/integrantes/:idParticipante/reativar',
      name: 'ReativarParticipacao',
      component: ReativarParticipacao,
      props: (route) => ({idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/integrantes/:idParticipante/ocorrencias',
      name: 'OcorrenciasIntegrante',
      component: OcorrenciasIntegrante,
      props: (route) => ({idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/integrantes/:idParticipante/trocar-coordenador',
      name: 'TrocarCoordenador',
      component: TrocarCoordenador,
      props: (route) => ({idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/integrantes/:idParticipante/frequencia',
      name: 'FrequenciaIntegrante',
      component: FrequenciaIntegrante,
      props: (route) => ({idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/integrantes/:idParticipante/frequencia/criar',
      name: 'CriarFrequencia',
      component: CriarFrequencia,
      props: (route) => ({idProjeto: route.params.idProjeto, idParticipante: route.params.idParticipante}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/nova-atividade',
      name: 'NovaAtividade',
      component: NovaAtividade,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/nova-parceria',
      name: 'NovaParceria',
      component: NovaParceria,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/nova-localidade',
      name: 'NovaLocalidade',
      component: NovaLocalidade,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/upload-arquivo',
      name: 'UploadArquivo',
      component: UploadArquivo,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/editar-arquivo/:idArquivo',
      name: 'EditarArquivo',
      component: EditarArquivo,
      props: (route) => ({idProjeto: route.params.idProjeto, idArquivo: route.params.idArquivo}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/relatorios/:idRelatorioExtensao',
      name: 'RelatorioTecnico',
      component: RelatorioTecnico,
      props: (route) => ({idProjeto: route.params.idProjeto, idRelatorioExtensao: route.params.idRelatorioExtensao})
    },
    {
      path: '/projetos/:idProjeto/relatorios/:idRelatorioExtensao/relatorio-pdf',
      name: 'RelatorioTecnicoPDF',
      component: RelatorioTecnicoPDF,
      props: (route) => ({idProjeto: route.params.idProjeto, idRelatorioExtensao: route.params.idRelatorioExtensao}),
      meta: { requiresAuth: true, plainLayout: true }
    },
    {
      path: '/projetos/:idProjeto/novo-relatorio-tecnico',
      name: 'NovoRelatorio',
      component: NovoRelatorio,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/editar-relatorio/:idRelatorioExtensao?',
      name: 'EditarRelatorio',
      component: EditarRelatorio,
      props: (route) => ({idProjeto: route.params.idProjeto, idRelatorioExtensao: route.params.idRelatorioExtensao}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/editar-atividade/:idAtividade',
      name: 'EditarAtividade',
      component: EditarAtividade,
      props: (route) => ({idProjeto: route.params.idProjeto, idAtividade: route.params.idAtividade}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/editar-parceria/:idParceria',
      name: 'EditarParceria',
      component: EditarParceria,
      props: (route) => ({idProjeto: route.params.idProjeto, idParceria: route.params.idParceria}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/editar-localidade/:idLocalidade',
      name: 'EditarLocalidade',
      component: EditarLocalidade,
      props: (route) => ({idProjeto: route.params.idProjeto, idLocalidade: route.params.idLocalidade}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/superior',
      name: 'EditarProjetoSuperior',
      component: EditarProjetoSuperior,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/nova-pessoa',
      name: 'NovaPessoa',
      component: NovaPessoa,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/novo-membro-externo',
      name: 'CadastrarMembroExterno',
      component: CadastrarMembroExterno,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/finalizar',
      name: 'FinalizarAcao',
      component: FinalizarAcao,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/editar-pessoa/:idPessoa',
      name: 'EditarPessoa',
      component: EditarPessoa,
      props: (route) => ({idPessoa: route.params.idPessoa}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/relatorio',
      name: 'Relatorio',
      component: Relatorio,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true, plainLayout: true }
    },
    {
      path: '/projetos-aguardando-aprovacao',
      name: 'ProjetosAguardandoAprovacao',
      component: ProjetosAguardandoAprovacao,
      meta: { requiresAuth: true }
    },
    {
      path: '/relatorios-aguardando-aprovacao',
      name: 'RelatoriosAguardandoAprovacao',
      component: RelatoriosAguardandoAprovacao,
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos-vencidos',
      name: 'ProjetosVencidos',
      component: ProjetosVencidos,
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos-concluir',
      name: 'ProjetosConcluir',
      component: ProjetosConcluir,
      meta: { requiresAuth: true }
    },
    {
      path: '/aprovar-projeto/:idProjeto',
      name: 'AprovarProjeto',
      component: AprovarProjeto,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/devolver-projeto/:idProjeto',
      name: 'DevolverProjeto',
      component: DevolverProjeto,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/liberar-relatorio/:idProjeto',
      name: 'LiberarRelatorio',
      component: LiberarRelatorio,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/inabilitar-projeto/:idProjeto',
      name: 'InabilitarProjeto',
      component: InabilitarProjeto,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/alterar-classificacao-secundaria/:idProjeto',
      name: 'AlterarClassificacaoSecundaria',
      component: AlterarClassificacaoSecundaria,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/suspensao',
      name: 'SuspenderAcaoExtensao',
      component: SuspenderAcaoExtensao,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/reativacao',
      name: 'ReativarAcaoExtensao',
      component: ReativarAcaoExtensao,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/concluir-projeto/:idProjeto',
      name: 'ConcluirProjeto',
      component: ConcluirProjeto,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/cancelar-projeto/:idProjeto',
      name: 'CancelarProjeto',
      component: CancelarProjeto,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/desfazer-finalizacao/:idProjeto',
      name: 'DesfazerFinalizacao',
      component: DesfazerFinalizacao,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/desfazer-exclusao/:idProjeto',
      name: 'DesfazerExclusao',
      component: DesfazerExclusao,
      props: (route) => ({idProjeto: route.params.idProjeto}),
      meta: { requiresAuth: true }
    },
    {
      path: '/administracao',
      name: 'Administracao',
      component: Administracao,
      meta: { requiresAuth: true }
    },
    {
      path: '/pesquisa',
      name: 'Pesquisa',
      component: Pesquisa,
      meta: { requiresAuth: false }
    },
    {
      path: '/projetos-parceiros',
      name: 'ProjetosParceiros',
      component: ProjetosParceiros,
      meta: { requiresAuth: true }
    },
    {
      path: '/administracao/relatorios-de-gestao',
      name: 'RelatoriosGestao',
      component: RelatoriosGestao,
      meta: { requiresAuth: true }
    },
    {
      path: '/administracao/nova-mensagem',
      name: 'NovaMensagem',
      component: NovaMensagem,
      meta: { requiresAuth: true }
    },
    {
      path: '/administracao/usuarios-proex',
      name: 'UsuariosProex',
      component: UsuariosProex,
      meta: { requiresAuth: true }
    },
    {
      path: '/administracao/definir-periodo-frequencia',
      name: 'DefinirPeriodoFrequencia',
      component: DefinirPeriodoFrequencia,
      meta: { requiresAuth: true }
    },
    {
      path: '/administracao/relatorio-seguro',
      name: 'RelatorioSeguro',
      component: RelatorioSeguro,
      meta: { requiresAuth: true }
    },
    {
      path: '/administracao/registro-envio-relatorio',
      name: 'RegistrarEnvioDeRelatorioDeProjeto',
      component: RegistrarEnvioDeRelatorioDeProjeto,
      meta: { requiresAuth: true }
    },
    {
      path: '/administracao/reprovar-relatorios-suspensao-coordenador',
      name: 'ReprovarRelatorioComSuspensaoDeCoordenador',
      component: ReprovarRelatorioComSuspensaoDeCoordenador,
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/relatorios/:idRelatorio/submeter',
      name: 'SubmeterRelatorio',
      component: SubmeterRelatorio,
      props: (route) => ({idProjeto: route.params.idProjeto, idRelatorio: route.params.idRelatorio}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/relatorios/:idRelatorio/aprovar',
      name: 'AprovarRelatorio',
      component: AprovarRelatorio,
      props: (route) => ({idProjeto: route.params.idProjeto, idRelatorio: route.params.idRelatorio}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/relatorios/:idRelatorio/devolver',
      name: 'DevolverRelatorio',
      component: DevolverRelatorio,
      props: (route) => ({idProjeto: route.params.idProjeto, idRelatorio: route.params.idRelatorio}),
      meta: { requiresAuth: true }
    },
    {
      path: '/projetos/:idProjeto/relatorios/:idRelatorio/reprovar',
      name: 'ReprovarRelatorio',
      component: ReprovarRelatorio,
      props: (route) => ({idProjeto: route.params.idProjeto, idRelatorio: route.params.idRelatorio}),
      meta: { requiresAuth: true }
    },
    {
      path: '/administrador',
      name: 'AtivarDesativarAdministrador',
      component: AtivarDesativarAdministrador,
      meta: { requiresAuth: true }
    },
    {
      path: '/ajuda',
      name: 'Ajuda',
      component: Ajuda
    },
    {
      path: '/faq',
      name: 'Faq',
      component: Faq
    },
    {
      path: '/404',
      name: '404',
      component: PageNotFound
    }
  ]
})

router.beforeEach(async(to, from, next) => {
  projetos.getListaMensagem()
  .then(function (response) {
    store.dispatch('ui/SET_MENSAGEM', response.data.pop())
    next()
  })
  .catch(function () {
    next()
  })
})

router.beforeEach(async(to, from, next) => {
  if (!store.getters['auth/logged']) {
    auth.authenticated()
    .then(function (response) {
      store.dispatch('auth/SET_USERNAME', { username: response.data.uid })
      store.dispatch('auth/SET_NOME', { nome: response.data.nome })
      store.dispatch('auth/SET_VINCULO', { vinculo: response.data.vinculo })

      store.dispatch('auth/SET_ADMINISTRADOR', { administrador: response.data.administrador })
      store.dispatch('auth/SET_USUARIO_PROEX', { usuarioPROEX: response.data.usuarioPROEX })
      store.dispatch('auth/SET_PERMISSAO_CRIAR_PROJETO_EXTENSAO', { permissaoCriarProjetoExtensao: response.data.permissaoCriarProjetoExtensao })
      // store.dispatch('auth/SET_PERMISSAO_CRIAR_PROJETO_PESQUISA', { permissaoCriarProjetoPesquisa: response.data.permissaoCriarProjetoPesquisa })

      store.dispatch('auth/SET_LOGGED_IN')
      if (response.data.numeroAcesso < 1) {
        store.dispatch('ui/SHOW_MENSAGEM')
      }
      next()
    })
    .catch(function () {
      next()
    })
  } else {
    next()
  }
})

router.beforeEach(async(to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['auth/logged']) {
      auth.authenticated()
      .then(function (response) {
        store.dispatch('auth/SET_USERNAME', { username: response.data.uid })
        store.dispatch('auth/SET_NOME', { nome: response.data.nome })
        store.dispatch('auth/SET_VINCULO', { vinculo: response.data.vinculo })
        store.dispatch('auth/SET_ADMINISTRADOR', { administrador: response.data.administrador })
        store.dispatch('auth/SET_USUARIO_PROEX', { usuarioPROEX: response.data.usuarioPROEX })
        store.dispatch('auth/SET_PERMISSAO_CRIAR_PROJETO_EXTENSAO', { permissaoCriarProjetoExtensao: response.data.permissaoCriarProjetoExtensao })
        store.dispatch('auth/SET_LOGGED_IN')
        if (response.data.numeroAcesso < 1) {
          store.dispatch('ui/SHOW_MENSAGEM')
        }
        next()
      })
      .catch(function () {
        window.location = encodeURI(PIB_API_URL + '/')
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js